// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Endl","inner":"Form_inner__3Ka2q","range":"Form_range__2oFH5","name":"Form_name__bKHci","actions":"Form_actions__MOziY"};